import { green } from "@material-ui/core/colors";
import {
  grayColor,
  roseColor,
  primaryColor,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  whiteColor,
  twitterColor,
  facebookColor,
  googleColor,
  linkedinColor,
  pinterestColor,
  youtubeColor,
  tumblrColor,
  behanceColor,
  dribbbleColor,
  redditColor,
} from "../../styles";

const styles = (theme) => ({
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  outlined: {
    borderStyle: "solid",
    borderWidth: 1,
    backgroundColor: "transparent",
    "&:hover,&:focus": {
      backgroundColor: "transparent",
      color: whiteColor,
    },
    "&.outline-default": {
      borderColor: grayColor[0],
      color: grayColor[0],
    },
    "&.outline-primary": {
      borderColor: primaryColor[0],
      color: primaryColor[0],
    },
    "&.outline-info": {
      borderColor: infoColor[0],
      color: infoColor[0],
    },
    "&.outline-success": {
      borderColor: successColor[0],
      color: successColor[0],
    },
    "&.outline-warning": {
      borderColor: warningColor[0],
      color: warningColor[0],
    },
    "&.outline-danger": {
      borderColor: dangerColor[0],
      color: dangerColor[0],
    },
    "&.outline-rose": {
      borderColor: roseColor[0],
      color: roseColor[0],
    },
    "&.outline-white": {
      borderColor: whiteColor[0],
      color: whiteColor[0],
    },
    "&.outline-twitter": {
      borderColor: twitterColor[0],
      color: twitterColor[0],
    },
    "&.outline-facebook": {
      borderColor: facebookColor[0],
      color: facebookColor[0],
    },
    "&.outline-google": {
      borderColor: googleColor[0],
      color: googleColor[0],
    },
    "&.outline-linkedin": {
      borderColor: linkedinColor[0],
      color: linkedinColor[0],
    },
    "&.outline-pinterest": {
      borderColor: pinterestColor[0],
      color: pinterestColor[0],
    },
    "&.outline-youtube": {
      borderColor: youtubeColor[0],
      color: youtubeColor[0],
    },
    "&.outline-tumblr": {
      borderColor: tumblrColor[0],
      color: tumblrColor[0],
    },
    "&.outline-github": {
      borderColor: grayColor[7],
      color: grayColor[7],
    },
    "&.outline-behance": {
      borderColor: behanceColor[0],
      color: behanceColor[0],
    },
    "&.outline-dribbble": {
      borderColor: dribbbleColor[0],
      color: dribbbleColor[0],
    },
    "&.outline-reddit": {
      borderColor: redditColor[0],
      color: redditColor[0],
    },
    "&.outline-transparent": {
      borderColor: "transparent",
      color: "inherit",
    },
  },
});

export default styles;
